import { Stack, Typography } from '@mui/material';

import SaraCircleMark from '../SaraCircleMark';

export type Props = {
    content: string;
};

const ErrorMessageBubble = ({ content }: Props) => (
    <Stack alignItems="flex-start" direction="column" spacing={0.5} sx={{ maxWidth: '78%' }}>
        <SaraCircleMark size={24} variant="sara" />
        <Typography
            component="div"
            sx={{
                color: 'error.main',
                fontSize: 16,
                letterSpacing: '0.15px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
            }}
        >
            {content}
        </Typography>
    </Stack>
);

export default ErrorMessageBubble;
